import { useEffect, useState } from "react";
import { Table, Input, Button } from "antd";
import './templateTable.css';
import { serverAddress } from "../constant";
import axios from "axios";
import TemplatesModal from "./templatesModal";
import SendMessageModal from "./sendMessageModal";
import { notify_error, notify_success } from "./Notify";

const BulkUserTable = () => {
  const [users, setUsers] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedMobileNumbers, setSelectedMobileNumbers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");

  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isOpen3,setIsOpen3] = useState(false);
  const [isOpen4,setIsOpen4] = useState(false);
   const [message, setMessage] = useState("");
  
    const handleOpen = () => {
      console.log("Opening modal"); // Debugging log
      setIsOpen4(true);
    };
    const handleClose = () => {
      console.log("Closing modal"); // Debugging log
      setIsOpen4(false);
      setIsOpen3(false);
      setSelectedTemplate(null); // Reset selected template on close
      setMessage(""); 
    };

    const handleMessageChange = (event) => {
      setMessage(event.target.value);
    };


  const fetchTemplates = async () => {
    try {
      const response = await fetch(`${serverAddress}/template/get-all`);
      const data = await response.json();
      console.log("Templates:", data);	
      setTemplates(data);
    } catch (err) {
      console.error("Failed to fetch templates:", err);
    }
  };

  useEffect(() => {
    
  
    if (isOpen4) {
      fetchTemplates();
    }
  }, [isOpen4]);

  useEffect(() => {
    console.log("isOpen status",isOpen4)
  }, [isOpen4]);

  const handleTemplateClick = (template) => {
    setSelectedTemplate(template); 
    if (template.dynamic) {
      setIsOpen3(true);
    }
    else{
      console.log("Template ID:", template.template_sId);	
      handleSendMessage2(template.template_sId);
    }
  };
  const validateAndFormatNumber = (number) => {
    let formattedNumber = number.toString().trim();
  
    if (formattedNumber.length === 10) {
      return '+91' + formattedNumber;
    } else if (formattedNumber.length >= 12 && formattedNumber.length <= 13) {
      return formattedNumber; // Assume it's already in correct format
    } else {
      return null; // Invalid number
    }
  };

  const handleSendMessage = async () => {
    const templateid = selectedTemplate?.template_sId;
    const formattedNumbers = [];

    for (let number of selectedMobileNumbers) {
      const validNumber = validateAndFormatNumber(number);
      if (!validNumber) {
        notify_error(`Invalid mobile number: ${number}`);
        return; // Stop processing
      }
      formattedNumbers.push(validNumber);
    }
    console.log('Template-sid',templateid)
    const dataSent = {
      mobileNumbers: formattedNumbers,
      message: message,
      template: templateid
    };
    try {
      await axios.post(
        `${serverAddress}/website/enquiry/bulk/whatsapp`,
        dataSent
      );
      notify_success("Message sent successfully!");
      setMessage("");
      handleClose();
      setIsOpen3(false);
      setMessage("");
      setSelectedTemplate(null); 
      setSelectedRowKeys([])// Reset selected template after sending
    } catch (error) {
      console.error("Error sending message:", error);
      notify_error("Failed to send message.");
      setIsOpen3(false);
        setSelectedTemplate(null); // Reset selected template on error
        setMessage("");
        setSelectedRowKeys([]) // Clear message input on error
    }
  };

  const handleSendMessage2 = async (templateid) => {
    //const templateid = selectedTemplate?.template_sId;
    const formattedNumbers = [];

    for (let number of selectedMobileNumbers) {
      const validNumber = validateAndFormatNumber(number);
      if (!validNumber) {
        notify_error(`Invalid mobile number: ${number}`);
        return; // Stop processing
      }
      formattedNumbers.push(validNumber);
    }
    console.log('Template-sid',templateid)
    const dataSent = {
      mobileNumbers: formattedNumbers,
      message: message,
      template: templateid
    };
    try {
      await axios.post(
        `${serverAddress}/website/enquiry/bulk/whatsapp`,
        dataSent
      );
        notify_success("Message sent successfully!");
      setMessage("");
      handleClose();
      setIsOpen3(false);
      setMessage("");
      setSelectedTemplate(null); 
      setSelectedRowKeys([])// Reset selected template after sending
    } catch (error) {
      console.error("Error sending message:", error);
      notify_error("Failed to send message.");
      setIsOpen3(false);
      setMessage("");
      setSelectedTemplate(null); 
      setSelectedRowKeys([])// Reset selected template after sending
    }
  };

  // Debounce search
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery.trim());
    }, 400);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  // Fetch users
  const fetchUsers = async (query = "") => {
    setLoading(true);
    try {
      const res = await fetch(`${serverAddress}/bulk/users/get-all`);
      const data = await res.json();
      setUsers(data);
    } catch (err) {
      console.error("Failed to fetch users:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(debouncedQuery);
  }, [debouncedQuery]);

  useEffect(()=>{
    fetchUsers();
    console.log("Fetching users on component mount");	
  },[])

  const columns = [
    {
      title: "S.No.",
      render: (_, __, index) => index + 1,
      key: "sno",
      onHeaderCell: () => ({
        style: { backgroundColor: "#f2f5f7", fontSize: "16px", fontWeight: "bold" },
      }),
      onCell: () => ({
        style: { fontSize: "15px" },
      }),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      onHeaderCell: () => ({
        style: { backgroundColor: "#f2f5f7", fontSize: "16px", fontWeight: "bold" },
      }),
      onCell: () => ({
        style: { fontSize: "15px" },
      }),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      onHeaderCell: () => ({
        style: { backgroundColor: "#f2f5f7", fontSize: "16px", fontWeight: "bold" },
      }),
      onCell: () => ({
        style: { fontSize: "15px" },
      }),
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      onHeaderCell: () => ({
        style: { backgroundColor: "#f2f5f7", fontSize: "16px", fontWeight: "bold" },
      }),
      onCell: () => ({
        style: { fontSize: "15px" },
      }),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys, selectedRows) => {
      setSelectedRowKeys(selectedKeys);
      const mobiles = selectedRows.map(row => row.mobile);
      setSelectedMobileNumbers(mobiles);
    },
    
  };

  return (
    <div className="main-panel mt-5">
      <div className="content-wrapper">
        {/* <div
          style={{
            display: "flex",
            background: "white",
            padding: "8px",
            justifyContent: "space-between",
            alignItems: "end",
            marginBottom: 16,
          }}
        >
            <h3 style={{ margin: 0 }}>Bulk User Management</h3>
          <Input
            placeholder="Search users"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            suffix={<SearchOutlined />}
            style={{
              width: 300,
              borderRadius: "8px",
              marginRight: 8,
              marginBottom: "4px",
            }}
          />
        </div> */}
        <div style={{ display: "flex",background:"white", padding:"8px", justifyContent: "end", alignItems: "end", marginBottom: 16 }}>
        
        {/* <Input
          placeholder="Search by Template Name or ID"
          
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          suffix={<SearchOutlined />}
          style={{ width: 300, borderRadius: "8px", marginRight: 8, marginBottom:"4px" }}
        /> */}
          <Button type="primary"
          style={{
            backgroundColor: "#663399",
            color: "#fff",
            borderColor: "#663399",
            width: "auto",
            padding: "8px 12px", // Reduced padding for smaller buttons
            height: "38px", // Slightly reduced height
            whiteSpace: "nowrap",
            borderRadius: "8px",
            transition: "none", 
            marginTop:"2px",
            marginBottom:"2px",
            fontWeight:"700",
          }}
           onClick={handleOpen}
           >
            Send Bulk Message
          </Button>
          
        </div>

        <Table
          rowSelection={rowSelection}
          dataSource={users}
          columns={columns}
          rowKey="_id"
          rowClassName={() => 'no-select-bg'}
          loading={loading}
          pagination={{ pageSize: 10 }}
          style={{ background: "white" }}
          className="no-border-table"
        />
         {isOpen4 && (
  <TemplatesModal
    visible={isOpen4}
    onClose={handleClose}
    templates={templates}
    onTemplateClick={handleTemplateClick}
  />
)}

{isOpen3 && (
  <SendMessageModal
  visible={isOpen3}
  onClose={() => setIsOpen3(false)}
  message={message}
  onMessageChange={handleMessageChange}
  onSend={handleSendMessage}
/>
)}

        {/* Debug section - remove in production */}
        
      </div>
    </div>
  );
};

export default BulkUserTable;
